import * as core from '../../../../../../../core'

import { query } from './cursor-hours-saved.query'

export const RESOURCE = {
  payload: {
    alias: 'cursor.hours.saved',
    description:
      'Total estimated productivity time saved through Cursor usage. Not yet implemented.',
    name: 'Cursor Hours Saved',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
